<div class="feed-operators">
  <div class="feed-operators-header">
    <app-search-input
      [value]="searchQuery"
      (inputChanged)="onSearchChange($event)"
    ></app-search-input>
    <div class="header-name">
      {{ "feed-operator-list.title.name" | translate }}
    </div>
    <div class="header-description">
      {{ "feed-operator-list.title.description" | translate }}
    </div>
    <div class="header-add">
      {{ "feed-operator-list.title.action" | translate }}
    </div>
  </div>
  <div class="feed-operators-list">
    @for (feedOperator of filteredFeedOperators; track feedOperator) {
      <div class="feed-operator">
        <div
          class="name"
          [innerHTML]="feedOperator.name | highlight: searchQuery"
        ></div>
        <div class="description">{{ feedOperator.description }}</div>
        <div class="add-operator">
          <sui-button
            size="sm"
            variant="primary"
            (click)="addOperator(feedOperator)"
          >
            {{ "btn.add" | translate }}
          </sui-button>
        </div>
      </div>
    }
  </div>
</div>
